import { isNil } from "lodash";
const formats = [{
  rating: 1000 * 1000 * 1000,
  markup: "B"
}, {
  rating: 1000 * 1000,
  markup: "M"
}, {
  rating: 1000,
  markup: "K"
}];
export const formatDeliveries = rating => {
  const format = formats.find(({
    rating: minRating
  }) => rating > minRating);
  return format ? `${Math.floor(rating / format.rating)}${format.markup} +` : `${rating}`;
};
export const markupDeliveries = rating => typeof rating === "number" ? formatDeliveries(rating) : rating;
export const showRating = rating => +rating > 3;
export const showYears = years => !isNil(years) && years > 0;